import {TCompanyAware, TLifecycle} from "./traits";
import {TOperation} from "./operation";

export enum TEmailTemplateType {
  PARTICIPANT_INVITATION = 'PARTICIPANT_INVITATION',
  PARTICIPANT_TICKET = 'PARTICIPANT_TICKET',
  PARTICIPANT_ORDER = 'PARTICIPANT_ORDER',
  PARTICIPANT_RELAUNCH = 'PARTICIPANT_RELAUNCH',
  CUSTOM_TEMPLATE = 'CUSTOM_TEMPLATE',
  ACCOUNT_VALIDATION = 'ACCOUNT_VALIDATION',
  RESET_ADMIN_PASSWORD = 'RESET_ADMIN_PASSWORD',
  RESET_PARTICIPANT_PASSWORD = 'RESET_PARTICIPANT_PASSWORD',
  REMINDER_PARTICIPANT_OPERATION_IS_ABOUT_TO_END = 'REMINDER_PARTICIPANT_OPERATION_IS_ABOUT_TO_END',
  REMINDER_PARTICIPANT_MONTH = 'REMINDER_PARTICIPANT_MONTH',
}

export interface TEmailTemplate extends TLifecycle, TCompanyAware {
  templateType: TEmailTemplateType;
  mailjetId: number;
  operation: TOperation;
  name: string;
  subject?: string;
  mailSender?: string | null;
  periodicity?: number | null;
  extraVariables: any;
  components: TEmailTemplateComponent[];
  newPointAdded :boolean;
  newParticipantAdded :boolean;
  beginOperationAdded :boolean;
}

export enum TEmailTemplateComponentType {
  BUTTON = 'button',
  TEXT = 'text',
  BANNER = 'banner',
  HEADER = 'header',
  FOOTER = 'footer',
}

export type TUrlType = "shop" | "manual";

export interface TEmailTemplateComponent {
  id: string;
  emailTemplateId: string;
  order: number;
  type: TEmailTemplateComponentType;
  contenu?: string | null;
  label?: string | null;
  url?: string | null;
  alt?: string | null;
  img?: string | null;
  urlType?: TUrlType | null;
}

export interface TEmailTemplateComponentCreate {
  emailTemplate: string;
  order: number;
  type: TEmailTemplateComponentType;
  contenu?: string | null;
  label?: string | null;
  url?: string | null;
  alt?: string | null;
  img?: string | null;
  urlType?: TUrlType | null;
}

export interface TComponentPayload {
  order: number;
  type: TEmailTemplateComponentType;
  contenu?: string | null;
  label?: string | null;
  url?: string | null;
  alt?: string | null;
  img?: string | null;
  urlType?: TUrlType | null;
}

export interface TEmailTemplateCreate {
  templateType: TEmailTemplateType;
  mailjetId?: number;
  operation: string;
  name: string;
  subject?: string | null;
  mailSender?: string | null;
  periodicity?: number;
  extraVariables: any;
  components?: TComponentPayload[];
  newPointAdded :boolean;
  newParticipantAdded :boolean;
  beginOperationAdded :boolean;
}

export interface TEmailSentResponse {
  sent: TEmailSent;
  errors: any[];
}

export interface TEmailSent {
  count: number;
  participants: string[];
  errors: string[];
}
export interface TEmailStats {
  id: string;
  opens: number;
  sent: number;
}

export interface TEmailInvitationSummary {
  clicked: number;
  received: number;
  totalInvited: number;
}

export interface TEmailStatsResponse {
  perTemplate: TEmailStats[];
  invitationSummary: TEmailInvitationSummary;
}

export interface TEmailForListing extends TLifecycle {
  id: string;
  type: string;
  participant: string;
  status: TEMailStatus;
  sendAt: string;
}

export interface TPlannedEmail extends TLifecycle {
  id: string;
  emailCount: number;
  sendAt: string;
}

export enum TEMailStatus {
  JZ_PENDING = 'jz_0',
  JZ_CURRENT = 'jz_3',
  MJ_OPEN = 'mj_0',
  MJ_CLICK = 'mj_1',
  MJ_BOUNCE = 'mj_2',
  MJ_SPAM = 'mj_3',
  MJ_BLOCKED = 'mj_4',
  MJ_UNSUB = 'mj_5',
  SENT = 'sent',
  UNKNOWN = 'unknown',
}
